.textarea {
  width: 100%;
  resize: none;
  display: block;
  border: none;
}

.readOnly {
  padding: 5px 6px;
  background-color: var(--main-background);
}
